module.exports = __webpack_public_path__ + "h5/img/bs_10.991e62ce.jpeg";